export default class NavigationHelper {
  static openInNewTab = (url: string): void => {
    window.open(url, '_blank')?.focus();
  };

  /**
   * Очищает URL от параметров react-router-dom, например '/login/:markerCode?' > '/login'
   * @param path - URL из объекта routes
   */
  static cleanRoute = (path: string) => {
    return path.replace(/\/:[^/?]+(\?)?/g, '');
  };

  /**
   * Заменяет в URL от параметры react-router-dom, например '/work-orders/:id' > '/work-orders/968564'
   * @param path - полный URL
   * @param id - новый ID
   */
  static setId = (path: string, id: string | number) => {
    return `${this.cleanRoute(path)}/${id}`;
  };
}
